<template>
  <div class="filter-section">
    <label class="filter-label">Sort by</label>
    <div class="filter-row">
      <select v-model="field" class="form-select form-select-sm flex-grow-1" style="border-color:#ccc">
        <slot />
      </select>
      <button v-if="directionLabel"
        type="button"
        class="btn btn-sm btn-outline-dark btn-filter-direction"
        :title="directionLabel"
        @click="$emit('update:ascending', !ascending)"
      >
        <i :class="`bi-arrow-${ascending ? 'up' : 'down'}`" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: String,
    ascending: Boolean,
    directionLabel: String
  },
  emits: ['update:modelValue', 'update:ascending'],
  computed: {
    field: {
      get() {
        return this.modelValue;
      },
      set(v) {
        this.$emit('update:modelValue', v);
      }
    }
  }
}
</script>

<style scoped>
.btn-filter-direction {
  border-color: #CCCCCC;
}
</style>
